export default function Location() {
  return (
    <section id="location" className="relative py-32 px-8 overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/demo/hotel-site/images/location.png"
          alt="Tokyo Location"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/60 to-black/50"></div>
      </div>
      <div className="relative z-10 max-w-7xl mx-auto">
        <div className="max-w-2xl text-white">
          <p className="text-sm tracking-widest uppercase mb-6">東京、極上の地</p>
          <h3 className="text-5xl md:text-6xl font-serif mb-8 leading-tight">
            都心にありながら、静謐を纏う
          </h3>
          <p className="text-lg leading-relaxed mb-6 text-white/90">
            大手町駅直結、東京駅から車で5分。ビジネスの中枢にありながら、皇居の緑を望む稀有な立地。銀座、丸の内も徒歩圏内です。
          </p>
          <p className="text-base leading-relaxed mb-8 text-white/90">
            国立近代美術館、東京国立博物館、歌舞伎座。日本文化の精華が集う地で、知的好奇心を満たす滞在を。
          </p>
          <button className="px-10 py-4 bg-white text-gray-900 text-sm tracking-widest whitespace-nowrap hover:bg-gray-100 transition-colors">
            アクセス
          </button>
        </div>
      </div>
    </section>
  );
}